const CustomerSalesOrder = {

    // FIELDS
    "customer_information": "Customer Information",
    "type": "Type",
    "vehicle": "Vehicle",
    "customer": "Customer",
    "sale_type": "Sale Type",
    "currency": "Currency",
    "order_booked_by": "Order Booked By",
    "booking_date": "Booking Date",
    "delivery_date": "Delivery Date",
    "delivery_type": "Delivery Type",
    "delivery_terms": "Delivery Terms",
    "payment_terms": "Payment Terms",
    "customer_po_number": "Customer PO Number",
    "customer_po_date": "Customer PO Date",
    "designation": "Designation",
    "quotation_code": "Quotation Code",
    "credit_days": "Credit Days",
    "our_code_customer_end": "Our Code at Customer End",
    "remark": "Remark",
    "dispatch_address": "Dispatch Address",
    "dispatch_address_id": "Dispatch Address Id",
    "currency_id": "Currency Id",

    "item_information": "Item Information",
    "item": "Item",
    "rate": "Rate",
    "quantity": "Quantity",
    "unit": "Unit",
    "discount": "Discount (%)",
    "vat": "VAT (%)",
    "sub_total": "Sub Total",
    "total": "Total",
    "total_weight": "Total Weight",
    "search": "Search",

    // PAGE HEADER
    "sales_order": "Sales Order",

    // SWEET ALERT
    "filter_alert": "Choose Delivery Date",
    "repeated_item": "Repeated Item",
    "already_exist": "Item already exists. Update its Quantity",

    // ERROR
    "error_customer": "Select Customer",
    "error_type": "Select Type",
    "error_vehicle": "Select Vehicle",
    "error_address": "Choose Address",
    "error_currency": "Select Currency",
    "error_user": "Select User",
    "error_booking_date": "Choose Booking Date",
    "error_delivery_date": "Choose Delivery Date",
    "error_delivery_type": "Select Delivery Type",
    "error_po_number": "Enter PO Number",
    "error_po_date": "Choose PO Date",
    "error_item": "Select Item",
    "error_rate": "Enter Rate",
    "error_quantity": "Enter Quantity",
    "error_unit": "Select Unit",
    "error_discount": "Enter Discount",
    "error_vat": "Enter VAT",
    "error_positive": "Positive Only",
    "error_sales_type": "Select Sale Type",
    "error_delivery_terms": "Enter Delivery Terms",
    "error_payment_terms": "Enter Payment Terms",
    "error_designation": "Enter Designation",
    "error_quotation_code": "Enter Quotation Code",
    "error_credit_days": "Enter Credit Days",
    "error_code": "Enter Code",
    "error_remark": "Enter Remark",

    // TABLE HEADER
    "table_sales_order_code": 'SO CODE',
    "table_booking_date": 'BOOKING DATE',
    "table_delivery_date": 'DELIVERY DATE',
    "table_total_item": "TOTAL ITEM",
    "table_total_value": "TOTAL VALUE",
    "table_customer": "CUSTOMER",
    "table_van_sale": "VAN SALE",
    "table_city": "CITY",
    "table_status": "STATUS",

    // DISPATCH ADVICE ROUTES
    "dispatch_advice": "Dispatch Advice",
    "da_route_planning": "Dispatch Advice Route Planning",
    "route": "Route",
    "default_route": 'Default Route',
    "action": "Action",

    // ERROR FOR DISPATCH ADVICE ROUTES
    "error_dispatch_advice": "Select Dispatch Advice",
    "error_route": "Select Route",
    "error_dispatch_advice_not_found": "Dispatch Advice Not Found",

}

export default CustomerSalesOrder